export default {
  area: "Area",
  all_areas: "All Areas",
  change_requests: "Change Requests",
  identification: "Identification",
  issues: "Issues",
  label_area_id: "Area ID",
  label_attr_set: "Area Attribute Set",
  label_designation: "Designation",
  label_attr_example: "Attribute example 1",
  label_layout_group: "Layout group",
  promoted_areas: "Promoted Areas",
  remaining_areas: "Remaining Areas",
  subtitle: "Area Overview",
  tab_attached: "Attached",
  tab_data: "Data",
  tab_layout: "Layout",
  tab_overview: "Overview",
  title: "Areas",
  work_orders: "Work Orders",
}
